export const generationStatus = {
  generated: 'GENERATED',
  generating: 'GENERATING',
  withErrors: 'WITH_ERRORS',
};
